import { Box, Skeleton, Stack } from '@mui/material'
import { Divider, SkeletonText } from 'utoniq-ui'

import { Organism } from '@/core/architecture'

type MagazineItemSkeletonProps = {
  divider?: boolean
}

export const MagazineItemSkeleton: Organism<MagazineItemSkeletonProps> = ({
  divider,
}) => (
  <Stack>
    <Stack flex={1} direction="row" spacing={4}>
      <Box>
        <Skeleton variant="rectangular" width={60} height={96} />
      </Box>
      <Stack flex={1}>
        <SkeletonText variant="small" width="20%" />
        <SkeletonText variant="medium" lastWidth="33%" />
        <SkeletonText variant="medium" width="100%" />
        <SkeletonText variant="large" width="18%" />
      </Stack>
    </Stack>
    {divider && <Divider sx={{ mt: 2 }} />}
  </Stack>
)
